import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBUserStatus = Database["public"]["Enums"]["user_status"];

export const UserStatus = {
	PENDING: "pending",
	ACTIVE: "active",
	REVOKED: "revoked",
	REJECTED: "rejected",
} as const satisfies Record<string, DBUserStatus>;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

type _EnsureAllDBValues = Exclude<DBUserStatus, UserStatus> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const USER_STATUSES = Object.values(UserStatus) as readonly UserStatus[];

export const userStatusSchema = z.enum(UserStatus);
